import { call, takeLatest, put } from 'redux-saga/effects'
import log from "loglevel"

import BrowserPrint from '../../helpers/Printer/BrowserPrint-2.0.0.75.min';

function getPrinterDefaultFromAPI() {
    return new Promise((resolve, reject) => {
        BrowserPrint.getDefaultDevice("printer", device => {
            try {
                resolve(device ? device : undefined)
            } catch (error) {
                reject()
            }
        }, device => {
            reject("no printer");
        })
    })
}

function printerWriteFromAPI(selectedDevice, dataToWrite) {
    return new Promise((resolve, reject) => {
        if (selectedDevice) {
            selectedDevice.send(dataToWrite, 
                readData => resolve(readData), 
                errorMessage => reject(errorMessage)
            );
        } else {
            reject("no device")
        }
    })
}

function printerReadFromAPI(selectedDevice) {
    return new Promise((resolve, reject) => {
        if (selectedDevice) {
            selectedDevice.read(
                readData => (readData ? resolve(readData) : reject("No Response from Device")), 
                errorMessage => reject(errorMessage)
            );
        } else {
            reject("No device")
        }
    })
}

function* getPrinterDefault(data) {
    try {
        const printer = yield call(getPrinterDefaultFromAPI);

        yield put({ type: "GET_PRINTER_DEFAULT_SUCCESS", printer})

        yield call(printerRead, {printer})
    } catch (error) {
        yield put({ type: "GET_PRINTER_DEFAULT_FAIL"})
		log.info(error);
    }
}

function* printerWrite(payload) {
    try {
        if (!payload.printer) {
            payload.printer = yield call(getPrinterDefaultFromAPI);
        }

        yield call(printerReadFromAPI, payload.printer);

        const dataWrite = yield call(printerWriteFromAPI, payload.printer, payload.data);

        yield put({ type: "PRINTER_WRITE_SUCCESS", dataWrite})
    } catch (error) {
        yield put({ type: "PRINTER_WRITE_ERROR", error})
		log.info(error);
    }
}

function* printerRead(payload) {
    try {
        yield call(printerReadFromAPI, payload.printer);

        yield put({ type: "PRINTER_READ_SUCCESS"})
    } catch (error) {
		log.info(error);
    }
}

export function* getPrinterWatcher() {
    yield takeLatest("GET_PRINTER_DEFAULT", getPrinterDefault)
    yield takeLatest("PRINTER_WRITE", printerWrite)
    yield takeLatest("PRINTER_READ", printerRead)
}
